module.exports = __webpack_public_path__ + "stacked-boxes.33c58747353f928d7ccb7a72528eb900.svg";